<br>
  <div>
    <span class="headerText">Quotes</span>
    <div class="flex-header">
      <span>
        <h6>Show:</h6>
        <p-selectButton [options]="types" [(ngModel)]="selectedType" (onChange)="changedType()"></p-selectButton>
      </span>
      <p-button type="button" class="add-new-button" (click)="addNew();">Add New</p-button>
    </div>
  </div>

  @if (selectedType === 'quoteRequest') {
    <p-table showGridlines stripedRows responsiveLayout="stack"
      #qrTable
      [columns]="cols"
      [value]="quoteRequests"
      [paginator]="true"
      [rows]="30"
      [lazy]="true"
      (onLazyLoad)="loadRequestLazy($event)"
     
      [totalRecords]="totalRecords"
      [loading]="loading"
      [sortField]="'createdDate'"
      [sortOrder]="-1"
      >
      <ng-template pTemplate="caption">
        <div style="text-align: right">
          <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
          <input
            type="text"
            pInputText
            size="50"
            placeholder="Search Quote Requests..."
            [(ngModel)]="searchTerm"
            style="width:auto"
            (input)="qrTable.filterGlobal($event.target.value, 'contains')">
          </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            @for (col of columns; track col) {
              <th  [style.width]="col.width" [pSortableColumn]="col.field">
                {{col.header}}
                @if (col.header != '') {
                  <p-sortIcon [field]="col.field"  ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                }
              </th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-quoteRequest
          let-columns="columns"
          let-rowIndex="rowIndex">
          <tr>
            <td><span class="p-column-title">{{columns[0].header}}</span>{{quoteRequest.fullName}}</td>
            <td><span class="p-column-title">{{columns[1].header}}</span>{{quoteRequest.phoneNumber | phoneNumber}}</td>
            <td><span class="p-column-title">{{columns[2].header}}</span>{{quoteRequest.address}}</td>
            <td><span class="p-column-title">{{columns[3].header}}</span>{{quoteRequest.state}}</td>
            <td><span class="p-column-title">{{columns[4].header}}</span>{{quoteRequest.zip}}</td>
            <td><span class="p-column-title">{{columns[5].header}}</span>{{quoteRequest.completionStatus}}</td>
            <td><span class="p-column-title">{{columns[6].header}}</span>
            @if (quoteRequest.type == 'Anytime') {
              <span>N/A</span>
            }
            @if (quoteRequest.type == 'Virtual') {
              <span>N/A</span>
            }
            @if (quoteRequest.type == 'Firmtime') {
              <span>{{quoteRequest.paymentStatus}}</span>
            }
          </td>
          <td><span class="p-column-title">{{columns[5].header}}</span>{{quoteRequest.createdDate | date: 'shortDate'}}</td>
          <td><span class="p-column-title">{{columns[6].header}}</span>{{quoteRequest.isUrgent ? 'Yes' : 'No' }}</td>
          <td>
            <p-button
              
              type="button"
              icon="pi pi-pencil"
              (click)="edit(quoteRequest)"
              severity="info" >
            </p-button>
            @if (showDeleteForRFQ(quoteRequest)) {
              <p-button
                
                type="button"
                icon="pi pi-trash"
                (click)="delete(quoteRequest)"
                severity="danger"
                >
              </p-button>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  }

  @if (selectedType === 'quote') {
    <div>
      <app-work-order-list [showHeaders]="false"></app-work-order-list>
    </div>
  }